module.exports = __webpack_public_path__ + "static/media/membership-dinein.f155c01d.png";